<template>
  <div class="login-wrap">
    <div class="login-tip">
      <i class="el-icon-info"></i>
      <div>{{ tipText }}</div>
    </div>

    <p class="title">政府采购评价系统</p>

    <!-- 页面中间的白色盒子 -->
    <div class="login-box">
      <el-form :model="formData" :rules="rules" ref="loginRef" @keyup.13.native="handleSub" label-width="75px">
        <el-form-item label="用户名" prop="username">
          <el-input v-model="formData.username" placeholder="" prefix-icon="el-icon-user" type="text"
            clearable></el-input>
        </el-form-item>

        <el-form-item label="密码" prop="password">
          <el-input v-model="formData.password" placeholder="" prefix-icon="el-icon-key" show-password
            clearable></el-input>
        </el-form-item>

        <el-form-item label="验证码" prop="verCode">
          <div class="inline-group">
            <el-input v-model="formData.verCode" placeholder="不区分大小写" clearable></el-input>
            <el-tooltip effect="light" content="点击可切换验证码" placement="right">
              <s-identify @getRealCode="getRealCode" />
            </el-tooltip>
          </div>
        </el-form-item>

        <div class="text-center">
          <el-button type="primary" @click="handleSub">登 &nbsp; 录</el-button>
          <el-link href="/publicity" type="primary" style="float: right; margin-top: 1.7rem">公示栏<i
              class="el-icon-right"></i></el-link>
        </div>
      </el-form>
    </div>
    <ul class="light-bg">
      <li v-for="n of 8" :key="n"></li>
    </ul>
  </div>
</template>
<script>
import SIdentify from "common/verification/index.vue";
import { login } from "@/api";
import { getPermission } from "@/router/auth";
import { DynamicRoutes } from "@/router/permission.js";

export default {
  components: { SIdentify },
  data() {
    // 自定义验证：检测验证码
    var checkCode = (rule, value, callback) => {
      if (!value) return callback(new Error("验证码不能为空"));

      if (value.trim().toUpperCase() != this.realCode.toUpperCase()) {
        return callback(new Error("验证码不正确"));
      }

      callback();
    };
    return {
      formData: {
        username: "",
        password: "",
        verCode: "",
      },
      // 表单验证
      rules: {
        username: [{ required: true, message: "请输入账号", trigger: "blur" }],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }],
        verCode: [{ validator: checkCode, trigger: "blur" }],
      },

      realCode: "", // 正确的验证码
      showTip: false,
      tipText:
        "修改后的密码是满足于 大小写英文字符、数字、特殊字符（.@#$%^&*`~_）中的三个并且长度不小于7。如有需要请联系管理员重置密码！",
    };
  },
  created() {
    const info = this.$store.state.loginInfo;

    // 先清除session缓存
    window.sessionStorage.clear();

    if (info.userName !== undefined && info.userName !== "") {
      // 刷新可以清除vuex中的数据
      window.location.reload();
    }
  },
  methods: {
    // 点击验证码，会更换新的
    getRealCode(code) {
      this.realCode = code;
    },

    // 提交按钮
    async handleSub() {
      this.$refs["loginRef"].validate(async (valid) => {
        if (!valid) return;

        const res = await login(this.formData);

        if (res.status !== 200) return this.$message.error(res.message);

        let { token } = res.data,
          roleId = res.data.roles[0].id,
          { username, id } = res.data.user;

        const loginInfo = {
          roleId,
          userName: username,
          userId: id,
        };

        // 保存登录信息
        this.$store.commit("SAVELOGININFO", loginInfo);
        this.$store.commit("SAVETOKEN", token);

        let menus = getPermission(roleId); //根据用户的角色id获取到相应的用户路由信息

        // 保存用户路由权限
        this.$store.commit("SETMENU", menus);

        this.$message({
          message: "登录成功！",
          type: "success",
          duration: 1700,
        });

        setTimeout(() => {
          // 动态添加角色路由
          DynamicRoutes();

          // 动态路由，因为每个角色的页面都不一样
          this.$router.push(menus[0].path);
        }, 800);
      });
    },
  },
};
</script>
<style lang="less">
.login-wrap {
  width: 100%;
  height: 100%;
  background: linear-gradient(180deg, rgb(108, 183, 233), rgb(70, 128, 214));
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding-bottom: 10%;

  .title {
    margin-bottom: 1.5rem;
    color: #fff;
    font-size: 1.5rem;
    text-shadow: 1px 1px #2b2b2b69;
    letter-spacing: 2px;
  }

  .login-box {
    background: #fff;
    border-radius: 0.7rem;
    padding: 2rem 2rem;
    width: 470px;
    box-shadow: 2px 2px 14px #2b2b2b54;
    position: relative;
    z-index: 3;

    h3 {
      color: #454545;
      text-align: center;
      margin: 1rem;
      letter-spacing: 2px;
    }

    .el-form-item__label {
      letter-spacing: 1px;

      &::before {
        display: none;
      }
    }

    .el-input--prefix .el-input__inner {
      padding-left: 36px;
    }

    .el-input__icon {
      font-size: 1.15rem;
    }

    .el-button {
      margin-top: 0.6rem;
      margin-left: 1.5rem;
    }

    .inline-group {
      display: flex;

      .el-input {
        width: 42%;
        margin-right: 1rem;
        min-width: 138px;
      }
    }

    .el-input__inner {
      letter-spacing: 1px;
    }
  }

  // 左上角的图标提示按钮
  .login-tip {
    position: fixed;
    top: 1rem;
    left: 1.2rem;
    z-index: 3;
    cursor: pointer;

    div {
      color: #fff;
      opacity: 0;
      font-size: 14px;
      font-family: "黑体", "宋体";
      background: #ffffff3b;
      padding: 0.5rem;
      border-radius: 0.4rem;
      position: relative;
      margin: 9px 7px 0 -0.5rem;
      transition: all 0.3s;

      &::before {
        content: "";
        position: absolute;
        top: -10px;
        left: 0.5rem;
        width: 0;
        height: 0;
        border-left: 7px solid transparent;
        border-right: 7px solid transparent;
        border-bottom: 10px solid #ffffff47;
      }
    }

    .el-icon-info {
      color: #fff;
      opacity: 0.5;
      font-size: 1.4rem;
      transition: all 0.3s;

      &:hover {
        opacity: 0.7;
      }

      &:hover~div {
        opacity: 0.9;
      }
    }
  }
}

@media screen and (max-width: 500px) {
  .login-wrap {
    padding-bottom: 26%;

    .title {
      margin-bottom: 1rem;
    }

    .login-box {
      max-width: 93%;
      padding: 1.5rem 0.8rem 1.5rem 0.1rem;
    }
  }
}
</style>
